export default __webpack_public_path__ + "1c611a1d840f29c3042065ce33f3974d.png";